var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bigPage"},[_c('div',{staticClass:"page",on:{"click":_vm.openApp}},[_c('div',{staticClass:"header"})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask",attrs:{"id":"mask"}},[_c('img',{attrs:{"src":require("../../assets/images/1656743361000.png"),"alt":""}})])
}]

export { render, staticRenderFns }